export default {
  'APP': {
    'logoLink':'https://www.hkma.gov.hk/gb_chi/',
    'tiptitle':[
      '字体大小 100%',
      '字体大小 150%',
      '字体大小 200%',
      '播放验证码',
      '刷新验证码',
      '关闭',
      '验证码',
    ],
    'reminder':[
      '提醒'
    ],
    'title': '香港金融管理局 - 有关银行产品或服务的投诉表格',
    'pTitle': [
      '第一部分. 投诉人资料',
      '第二部分. 投诉对象',
      '第三部分. 投诉內容',
      '第四部分. 投诉涉及的银行帐户或交易的资料',
      '第四部分. 有关投诉的补充资料（例如职员名片、银行复函、银行帐单、产品说明书等。）',
      '投诉人须知',
      '披露个案及个人资料的同意书',
      '无效页面',
    ],
    'mode': ['普通模式', '色盲模式'],
    'content':{
      // complaint模块里的三段内容
      'complaint':{
        'first':['若拟向香港金融管理局（「金管局」）投诉持牌银行、有限制牌照银行或接受存款公司（统称',
          '「银行」',
          '），请填妥本网上投诉表格。'
        ],
        'second':['在作出投诉前，请先参阅金管局的',
          '「常见问题（有关银行产品或服务的投诉）」',
          '及',
          '「处理银行投诉的流程图」',
          '，以便了解我们处理投诉的角色及程序。'
        ],
        'third':[
          '此外，我们鼓励你先向银行提出正式投诉，让银行有机会尽早解决你的投诉。请参阅金管局的',
          '「银行处理客户投诉的联络人名单」',
          '，当中载有该等专责人员的联络资料。'
        ],
        'forth':[
          '你须就金管局代表你处理你的投诉给予所需的同意，因为金管局可能需要为处理你的投诉而向有关银行或其他第三方披露你向金管局提供的资料（在需要时包括你的个人资料）。'
        ],
        // complaint里的链接
        'link':[
          'https://vpr.hkma.gov.hk/chi/regulatory-resources/registers/register-of-ais-and-lros/',
          'https://www.hkma.gov.hk/gb_chi/smart-consumers/frequently-asked-questions/banking/b/',
          'https://www.hkma.gov.hk/media/gb_chi/doc/other-information/flowchart_on_complaints_chi.pdf',
          'https://www.hkma.gov.hk/media/eng/doc/other-information/Banks_contact_persons.pdf'
        ],
        // 按钮文本
        'btn':[
          '进入'
        ]
      },
      // home模块里的内容
      'home':{
        'left':'（',
        'right':'）',
        'msg':[
          {
            'title':'（1）本人希望金管局考虑及处理本人的投诉。'
          },
          {
            'title':'（2）本人明白及同意，本人提供的所有个案及个人资料，将被用作与处理及/或调查本人的投诉及金管局履行法定职能相关的目的。'
          },
          {
            'title':'（3）本人明白及同意，（i）为与处理及/调查本人的投诉相关的目的；以及（ii）在法律许可或规定下，金管局可将本人提供的个案及个人资料向第三方披露或转移，包括被投诉的银行及/或其职员及其他相关监管机构、当局及执法机关。'
          },
          {
            'title':'（4）本人明白，若本人拟要求查阅或更改金管局所持本人的个人资料，本人可以书面方式向金管局法规及打击清洗黑钱部保障资料主任提出（地址：香港中环金融街8号国际金融中心2期55楼）。金管局可就依从查阅资料的要求收取合理费用。'
          },
          {
            'title':'（5）本人明白，本人无须向金管局提供个案及个人资料，并同意以自愿方式作出此举。若本人提供的个案或个人资料不准确或不完整，可能会影响本人的投诉的处理。'
          }
        ],
        'msg1':[
          {
            'title':'本人希望金管局考虑及处理本人的投诉。'
          },
          {
            'title':'本人明白及同意，本人提供的所有个案及个人资料，将被用作与处理及/或调查本人的投诉及金管局履行法定职能相关的目的。'
          },
          {
            'title':'本人明白及同意，（i）为与处理及/调查本人的投诉相关的目的；以及（ii）在法律许可或规定下，金管局可将本人提供的个案及个人资料向第三方披露或转移，包括被投诉的银行及/或其职员及其他相关监管机构、当局及执法机关。'
          },
          {
            'title':'本人明白，若本人拟要求查阅或更改金管局所持本人的个人资料，本人可以书面方式向金管局法规及打击清洗黑钱部保障资料主任提出（地址：香港中环金融街8号国际金融中心2期55楼）。金管局可就依从查阅资料的要求收取合理费用。'
          },
          {
            'title':'本人明白，本人无须向金管局提供个案及个人资料，并同意以自愿方式作出此举。若本人提供的个案或个人资料不准确或不完整，可能会影响本人的投诉的处理。'
          }
        ],
        // 按钮文本
        'btn':['同意','不同意'],
        // 点击NOT AGREE弹出提示
        'tips':[
          '如你对我们处理个人资料有任何疑问，请以电邮与我们联络(',
          'bankcomplaints@hkma.gov.hk',
          ')。'
        ]
      },
      // note模块里的内容
      'note':{
        'msg1':[
          {
            'title': '本表格共有4个部份。你可按「下一步」按钮进入下一部份或「上一步」按钮返回上一部份。'
          },
          {
            'title': '如果你想暂时储存已输入的数据以便于稍后时间继续填写表格，请按该部份下方的「储存」按钮。你可利用这功能将数据储存到电脑的临时档案，该档案会被加密及以密码保护，但已上传的附件将不会被储存。有关临时档案将于7天后失效。'
          },
          {
            'title': '你可按下方的「载入已输入的资料」按钮，并从你的电脑中上载之前储存的临时档案及输入所需密码，以继续进行输入程序。'
          },
          {
            'title': '你可在本表格的最后一部份上载补充资料，每个档案不可大于10MB，每份投诉表格最多可上载10个档案。如需提供额外资料，你可透过电邮或邮件递交给我们。当你成功提交投诉表格后，系统会提供一个参考编号给你，请你在电邮或邮件中注明此编号。'
          }
        ],
        'msg2':[
          {'title':'你的电脑须符合以下设定：'},
          {'title':'浏览器：Google Chrome/Internet Explorer 9 或以上/Safari 5'},
          {'title':'解像度：1024 x 768'},
          {'title':'私隐级别：中等'},
          {'title':'如果你在载入投诉表格时遇到困难，请将安全级别更改至低或接受所有cookies。'},
        ],
        'msg21':[
          {'title':'5. 你的电脑须符合以下设定：'},
          {'title':' - 浏览器：Google Chrome/Internet Explorer 9 或以上/Safari 5'},
          {'title':' - 解像度：1024 x 768'},
          {'title':' - 私隐级别：中等'},
          {'title':' - 如果你在载入投诉表格时遇到困难，请将安全级别更改至低或接受所有cookies。'},
        ],
        'msg3':[
          {'title':'基于安全考虑，请勿使用公共电脑。'},
          {'title':'如需协助，请于办公时间内致电2878'},
          {'title':'1378。所有你和本局职员之间的电话谈话内容，无论是你的来电或我们的回复电话，都可能会被录音以确保我们的服务质素。'},
        ],
        // 按钮的文本
        'btn':['提出新投诉','载入已输入的资料'],
        // Lodge a new complaint按钮的文本
        'lodge':[
          '请输入以下验证码。',
          '输入验证码',
          '完成',
          '验证码错误，请输入上图中的验证码。'
        ],
        // Resume previous completion process按钮的文本
        'resume':{
          'header':['第一步、请选择临时档案。','选择文件'],
          'main':[
            '第二步、请输入密码。',
            '第三步、请输入以下验证码。',
            '完成',
            '请输入早前提供给你的6位数字密码。',
            '请选择已储存的临时文件。',
            '只接受HKMA格式的档案（*.hkma）。',
            '验证码或密码输入错误。',
            '请输入以HKMAbankcomplaint开头的文件。',
            '文件保存超过七天，无法恢复。',
            '您上载的临时档案/密码/验证码并不正确，请重新输入。',
            '恢复投诉单，传入的文件是空。',
            '密码错误。',
            '档案已失效。',
          ]
        }
      },
      //必填项改成这种提示625
      'mandatory':'此栏必须填写',
      // 公共部分
      'part':{
        'dialogTip':'你的资料将会储存到电脑的临时档案。',
        // 按钮组
        'btngroup':['上一步','储存','下一步','预览','提交','退出'],
        // 保存按钮的文本
        'savebtn':['你的资料将会被储存到你的电脑，你可在7天内开启已储存的档案以继续填写表格。已上载的附件将不会被储存，你需在恢复填写表格时重新上载附件。'],
        // 保存文件时弹出的弹框的文本
        'popout':['请保存以下密码，以便开启已储存的临时档案。','提示: 你尚未完成此投诉表格。你需在7日内填妥此表格的所有部份并递交表格。'],
        //下拉框
        'select':'选项',
        //For Exit Prompt
        'exitPrompt' : [
          '你确定离开此页?',
          '离开',
          '取消'
        ],
        //For Skip Ahead
        'skipAhead' : [
          '请先完成前面的部分。',
        ],
        //For Menu Aria-Label and Alt Text
        'menu' : [
          '步骤',
          '已完成',
          '尚未完成',
          '正在填写'
        ],
        // 提示
        'tips':[
          '此栏必须填写',
          '必填4位（字母或数字）',
          '请输入有效的电邮地址',
          '请输入姓氏',
          '请输入电话号码',
          '请选择地址类型',
          '与上述电邮地址不相同。请重新输入。',
        ],
        // 性别,点击选择框后的内容
        'genderList': [{
          'label': '选项',
          'value': ' '
         },{
          'label': '先生',
          'value': 'MR'
         },{
          'label': '太太',
          'value': 'MRS'
         },{
          'label': '女士',
          'value': 'MS'
         },{
          'label': '不适用',
          'value': 'NA'
         }],
        'addressList':[{
          'label':'寄回 - 通讯地址',
          'value':'1'
        },{
          'label':'通过电邮 - 电邮地址',
          'value':'2'
        }]
      },
      // part1模块里的内容
      'part1':{
        'title':['1. 投诉人资料'],
        // 表单内容
        'form':{
          'content':[
            '投诉是由个人或公司客户提出？',
            '个人',
            '公司'
          ],
          // 页面中相同的文本
          'common':{
            'method':[
              '邮寄',
              '电邮',
              '填写最少一项',
              '请填写通讯地址',
              '请提供相应的通讯地址及/或电邮地址。',
              '请提供相应的通讯地址及/或电邮地址。',
              
            ],
            'text':[
              '姓氏',
              '名字',
              '身份证明文件号码（首4个数字）',
              '通讯地址',
              '电邮地址',
              '电话号码',
              '你是否需要委任代表就你的投诉提交资料及查询进度？',
              '是',
              '否',
              '此栏必须填写',
              '请填写通讯地址及/或电邮。',
              '请填写必填项目。',
              '请输入姓氏',
              '请选择称呼',
              '请选择证件类型',
              '请输入名字',
              '与金管局的通信方式',
              '（一般而言，本局的复函会直接发给投诉人。）',
              '请再次输入电邮地址',
            ],
            // 证件类型,点击选择框后的内容
            'identityList': [
              {
              'label': '选项',
              'value': ' '
             },
             {
              'label': '香港身份证',
              'value': 'HKID'
             },{
              'label': '护照',
              'value': 'PASSPORT'
             },{
              'label': '旅游证件',
              'value': 'TRAVEL'
            }],
            // 地址是否相同
            'sameAddress': '和投诉人相同'
          },
          // 点击Individual按钮后的内容
          'individual':['投诉人姓名'],
          // 点击Corporate按钮后的内容
          'corporate':{
            'text':[
              '公司名称',
              '公司获授权代表',
              '（即董事/获授权签署人）',
              '公司是在哪一年成立的？',
              '公司是否在香港注册？',
              '公司主要经营什么业务？',
              '请输入公司名字',
              '请输入公司成立的时间',
              '请输入公司经营的业务',
              '年份格式范例: YYYY',
              '请输入正确的年份格式: YYYY',
            ]
          },
          // 委派代表的信息
          'delegate':['获委任代表的姓名','添加代表'],
          // 符号的解释
          'explain':['必须填写','填写最少一项'],
          // 填写代表的个数限制的弹框文本
          'representativenum':['不能添加超过2个代表。'],
          "complaintAgain":'你曾否向金管局作出与这宗個案有关的投诉？',
          "complaintNum":'投诉编号（如有）',
          "fieldError" : [
            "请填写必填项目。",
            "请填写必填项目。",
            "请檢查 '交易日期'",
            "请檢查 '争议金额'",
          ]
        }
      },
      // part2模块里的内容
      'part2':{
        'title':['2. 投诉对象'],
        'form':{
          'bankname':['银行名称'],
          // 銀行文案
          'bankText': {
            'name':'银行名称',
            'same':'同上',
            'branch':'分行 / 部门',
            'staff':'职员姓名',
            'sure':'姓氏',
            'first':'名字',
            'job':'职衔',
            'hkma':'金管局注册号码（如适用）',
            'have':'有否向有关银行投诉？',
            'y':'有',
            'n':'没有',
            'number':'银行的投诉个案编号',
            'date':'向银行提出投诉的日期：',
            'ifStaff':'投诉是否涉及银行职员？',
            'ifAccount':'投诉是否涉及银行帐户或交易？',
          },
          'explain':['必须填写'],
          'clickbox':['添加银行','添加银行职员'],
          'popout':'不能添加超过3个银行',
          'tips':[
            '请输入正确的日期格式（DD/MM/YYYY，DD/MM/YYYY，...）',
            '请输入分行或部门',
            '请输入职称',
            '请输入金管局登记号码',
            '输入的日期中存在相同的日期',
            '日期格式范例：DD/MM/YYYY，DD/MM/YYYY，...',
            '请输入银行名称',
            '请输入投诉是否涉及银行职员？',
            '请输入投诉是否涉及银行帐户或交易？',
            '请输入投诉有否向有关银行投诉？',
          ],
          'lodgedWithBank' : [
            '我们鼓励你先向银行提出正式投诉，让银行有机会尽早解决你的投诉。请参阅金管局的「',
            '银行处理客户投诉的联络人名',
            '」，当中载有该等专责人员的联络资料。',
          ],
          'dropdownLabel' : [
            '争议类型',
            '货币',
          ]
        }
      },
      // part3模块里的内容
      'part3':[
        '3. 投诉内容',
        '请逐项具体说明所有不满事项：',
        '添加项目',
        '请描述导致今次投诉的事件（按时间先后次序）。',
        '不能添加超过10行',
        '请提供所有不满事项及/或导致今次投诉的事件。'
      ],
      // part4模块里的内容
      'part4':{
        'title':['4. 投诉涉及的银行帐户或交易的资料'],
        'subtitle':['请提供投诉所涉及的帐户或交易详情：'],
        // 帐户类型
        'accounttype':[
          '户口类型',
          '个人户口',
          '联名户口',
          '公司户口'
        ],
        // 点击sole account和joint account按钮显示的内容
        'account':[
          '户口号码',
          '户口持有人姓名/名称',
          '姓氏',
          '名字',
          '产品名称',
          '交易日期',
          '争议金额',
          '交易日期',
          '交易月份',
          '交易年份',
        ],
        // 爭議類型
        'disputedtype': [
          {
            'label': '选项',
            'value': ''
          },
          {
            'label': '交易金额',
            'value': 'TRANSACTION'
          },
          {
            'label': '亏损',
            'value': 'LOSS'
          },
          {
            'label': '利息',
            'value': 'INTEREST'
          },
          {
            'label': '费用',
            'value': 'FEE'
          },
        ],
        // 幣種
        'currencytype':[
          {
            'label': '选项',
            'value': ''
          },
          {
            'label':'港元(HKD)',
            'value':'HKD'
          },
          {
            'label':'美元(USD)',
            'value':'USD'
          },
          {
            'label':'人民币(RMB)',
            'value':'RMB'
          },
          {
            'label':'英镑(GBP)',
            'value':'GBP'
          },
          {
            'label':'日圆(JPY)',
            'value':'JPY'
          },
          {
            'label':'欧罗(EUR)',
            'value':'EUR'
          },
          {
            'label':'瑞士法郎(CHF)',
            'value':'CHF'
          },
          {
            'label':'澳元(AUD)',
            'value':'AUD'
          },
          {
            'label':'加拿大元(CAD)',
            'value':'CAD'
          },
          {
            'label':'纽西兰元(NZD)',
            'value':'NZD'
          },
          {
            'label':'泰珠(THB)',
            'value':'THB'
          },
          {
            'label':'新加坡元(SGD)',
            'value':'SGD'
          },
          {
            'label':'瑞典克郎(SEK)',
            'value':'SEK'
          },
          {
            'label':'丹麦克郎(DKK)',
            'value':'DKK'
          },
          {
            'label':'其他(Others)',
            'value':'Others'
          }
        ],
        // 添加框
        'addbox':['添加户口/交易','添加户口持有人','添加戶口','添加交易'],
        // 争议金额
        'amountTip':'最多15位数字和4位小数',
        // 日期提示
        'dateTip':'日期格式不正确',
        // 弹框
        'popout':[
          '不能添加超过3个帐户持有人。',
          '不能添加超过10个帐户/交易。'
        ],
        'tips':[
          '请输入帐户号码',
          '请输入产品名称',
          '请输入2位数字的日期，如01、10等',
          '请输入2位数字的月份，如01、10等',
          '请输入4位数字的年份，如2019等',
        ]
      },
      // part5模块里的内容
      'part5':{
        'title':['4. 有关投诉的补充资料（例如职员名片、银行复函、银行帐单、产品说明书等）'],
        'doc':['添加档案'],
        'del':'删除',
        'upload':'上传中...',
        'memo':[
          '每个档案不可大于10MB。每份投诉表格最多可上载10个档案。档案格式只限于GIF，JPG，JPEG，PNG，TIFF，TIF，PDF。',
          '如档案大小超过上限或以其他格式储存，请电邮（',
          '）或邮寄至本局（香港中环金融街8号国际金融中心2期55楼香港金融管理局投诉处理中心）。'
        ],
        'attention':[
          '注意事项',
          '档案上传失败。请电邮或邮寄至本局。'
        ],
        'prompt':[
          '不能添加超过10个文档。',
          '档案格式只限于GIF，JPG，JPEG，PNG，TIFF，TIF，PDF。',
          '不可以上传相同文件'
        ]
      },

      //PREVIEW模块的内容
      'preview':[
        '预览',
        '更改',
        '我现递交本表格，并确认及同意下列事项：',
        '香港中环金融街8号',
        '电话：2878 1378',
        '国际金融中心2期55楼',
        '传真：2509 3990',
        '香港金融管理局',
        '电邮地址：',
        ' 所有你和本局职员之间的电话谈话内容，无论是你的来电或我们的回复电话，都可能会被录音以确保我们的服务质素。',
        '投诉处理中心',
        '部分',
        '目錄'
      ],
      //SUBMIT模块的内容
      'submit':[
        '你已递交投诉表格',
        '你的参考编号是',
        '如你要提交补充资料，请电邮（',
        '列印',
        '储存列印版本',
        '退出',
        '）或邮寄至本局（香港中环金融街8号国际金融中心2期55楼香港金融管理局投诉处理中心）。请在函件中注明以上参考编号。',
        '正在处理...',
        '你确定要退出本页吗？退出后将无法列印或储存表格。',
        '确认',
        '取消',
        '请储存此投诉表格的列印版本作纪录。',
      ],
      'submitDate':'递交日期',
      //wrongPage的内容
      'wrongPage':{
        'tips':[
          "抱歉，您不能直接进入此页面。",
          '请返回',
          '主页',
          '。',
        ]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/Language/simple.js